<!-- Header -->
<div class="modal-header">
  <h4 class="modal-title header-5">Filter by</h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="dismiss()"
  >
    <img
      [src]="isActive
        ? 'assets/images/virtusa-icons/close-dark.svg'
        : 'assets/images/virtusa-icons/close.svg'"
      alt="Close"
    />
  </button>
</div>

<!-- Body -->
<div class="modal-body mt-2">
  <div class="d-flex filter-wrapper">

    <!-- Left Sidebar -->
    <div class="filter-sidebar">
      <div
        *ngFor="let item of sidebarItems; let i = index"
        class="filter-nav-item"
        [class.active]="activeSectionIndex === i"
        (click)="scrollToSection(i)"
      >
        {{ item.label }}
      </div>
    </div>

    <!-- Right Content Panel (scrollable, all sections visible) -->
    <div class="filter-content" #contentPanel>

      <!-- Engine Type -->
      <div #filterSection class="filter-section">
        <p class="filter-section-label">Engine Type</p>
        <select class="filter-select" [(ngModel)]="selectedType">
          <option value="">Select engine type</option>
          <option *ngFor="let t of typeOptions" [value]="t.value">{{ t.value }}</option>
        </select>
      </div>

      <!-- Status -->
      <div #filterSection class="filter-section">
        <p class="filter-section-label">Status</p>
        <div class="af-status-chips">
          <button
            *ngFor="let s of statusOptions"
            class="af-status-chip"
            [class.af-status-chip--active]="isStatusSelected(s.value)"
            (click)="toggleStatus(s.value)"
          >
            <i class="bi bi-{{ s.icon }} af-status-chip__icon"></i>
            <span>{{ s.value }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Footer -->
<div class="modal-footer">
  <div class="d-flex justify-content-between w-100 align-items-center">
    <div
      class="btn btn-accello-tertiary reset-all-btn"
      (click)="reset()"
      (keydown.enter)="reset()"
    >
      Reset all
    </div>
    <button
      type="button"
      class="btn btn-accello-primary-light mx-2 m-auto me-0"
      (click)="apply()"
    >
      Apply
    </button>
  </div>
</div>
